import { render, staticRenderFns } from "./EventV2.vue?vue&type=template&id=579a2ab6&scoped=true&"
import script from "./EventV2.vue?vue&type=script&lang=js&"
export * from "./EventV2.vue?vue&type=script&lang=js&"
import style0 from "./EventV2.vue?vue&type=style&index=0&id=579a2ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a2ab6",
  null
  
)

export default component.exports